import { SelectionPermission } from 'store/productManagement/reducer.types';

type PermissionOption = { code: SelectionPermission; name: string };

export const PERMISSION_LABELS: Record<SelectionPermission, string> = {
  [SelectionPermission.ALL_OPTIONS]: 'In product - no restrictions',
  [SelectionPermission.FIXED_VALUE]: 'In product - defined value',
  [SelectionPermission.ALLOWED_VALUES]: 'In product - defined validity range',
  [SelectionPermission.RANGE_VALUE]: 'In product - defined range',
  [SelectionPermission.DEFAULT_VALUE]: 'In product - default value',
  [SelectionPermission.DISABLED]: 'Not in product',
};

const makeOptions = (codes: SelectionPermission[]): PermissionOption[] => {
  return codes.map((code) => ({ code, name: PERMISSION_LABELS[code] }));
};

export const defaultValuePermissionOptions = makeOptions([
  SelectionPermission.ALL_OPTIONS,
  SelectionPermission.FIXED_VALUE,
  SelectionPermission.DEFAULT_VALUE,
  SelectionPermission.DISABLED,
]);

export const permissionOptions = makeOptions([
  SelectionPermission.ALL_OPTIONS,
  SelectionPermission.FIXED_VALUE,
  SelectionPermission.DISABLED,
]);

export const requiredFixedValueFieldPermissionOptions = makeOptions([SelectionPermission.FIXED_VALUE]);

export const requiredFieldPermissionOptions = makeOptions([
  SelectionPermission.ALL_OPTIONS,
  SelectionPermission.FIXED_VALUE,
]);

export const rangeSpecificPermissionOptions = makeOptions([
  SelectionPermission.ALL_OPTIONS,
  SelectionPermission.ALLOWED_VALUES,
]);

export const definedRangePermissionOptions = makeOptions([
  SelectionPermission.ALL_OPTIONS,
  SelectionPermission.FIXED_VALUE,
  SelectionPermission.RANGE_VALUE,
  SelectionPermission.DISABLED,
]);
